import { render, staticRenderFns } from "./DagelijkseSoepEditOrder.vue?vue&type=template&id=133edf2d&"
import script from "./DagelijkseSoepEditOrder.vue?vue&type=script&lang=js&"
export * from "./DagelijkseSoepEditOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports